<div #dropdownMenu class="custom-form-dropdown">
    <button
        id="dropdown-btn"
        type="button"
        class="dropdownbtn"
        (click)="showMenu = !showMenu"
    >
        <span class="dropdown-display-text font-lato">
            <span *ngIf="hasSelectedItems()" class="selected-categories-text">
                <span class="mobile-text">
                    {{ getSelectedItemsDisplayText() }}
                </span>
                <span class="desktop-text">
                    {{ getSelectedItemsDisplayTextLarge() }}
                    <span
                        *ngIf="getRemainingCountText()"
                        class="remaining-count-text"
                        [matTooltip]="getRemainingItemsTooltip()"
                        matTooltipPosition="above"
                        matTooltipClass="custom-white-dropdown-tooltip">
                        {{ getRemainingCountText() }}
                    </span>
                </span>
            </span>
            <span *ngIf="!hasSelectedItems()">
                {{ 'faq.categoryDefault' | translate }}
            </span>
        </span>
        <mat-icon
            class="dropdown-icon transition-transform duration-200"
            [ngClass]="{ 'rotate-180': showMenu }">
            expand_more
        </mat-icon>
    </button>
    <ul class="dropdown-options" [class.show]="showMenu">
        <div class="search-container border-b pb-4">
            <app-search
                [placeholder]="'placeholder.search' | translate"
                [(value)]="params.searchString"
                (inputChange)="filterCategoryDropdown(params.searchString)"
                (callback)="filterCategoryDropdownImmediate(params.searchString)">
            </app-search>
        </div>
        @if (filteredDropdownList.length > 0) {
            <ng-container *ngFor="let item of filteredDropdownList">
                <ng-container *ngTemplateOutlet="renderCategory; context: { $implicit: item }"></ng-container>
            </ng-container>
        }
        @else {
            <div class="mt-4 text-[#4B4848] font-lato">
                {{ 'faq.emptyTitle' | translate }}
            </div>
        }
    </ul>
</div>

<ng-template #renderCategory let-item>
    <ul>
        <li>
            <div class="flex items-center category-item">
                <button
                    type="button"
                    class="flex items-center"
                    [ngClass]="{ 'cursor-default': item.childCategories.length === 0 }"
                    (click)="toggleExpansion(item)">
                    <mat-icon>
                        {{
                            item.childCategories.length > 0 ? 
                                (item.isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down') :
                                ''
                        }}
                    </mat-icon>
                </button>
                <div>
                    <mat-checkbox
                        [checked]="isSelected(item.id)"
                        [indeterminate]="isParentIndeterminate(item)"
                        (change)="toggleSelection(item.id, item.name, item.childCategories)">
                        <span class="font-lato text-base">
                            {{ item.name }}
                        </span>
                    </mat-checkbox>
                </div>
            </div>
            <ul *ngIf="item.isExpanded && item.childCategories.length > 0">
                <ng-container *ngFor="let child of item.childCategories">
                    <ng-container *ngTemplateOutlet="renderCategory; context: { $implicit: child }"></ng-container>
                </ng-container>
            </ul>
        </li>
    </ul>
</ng-template>
